export const getRate = 'getRate';
export const removeToastById = 'removeToastById';
export const changeSocketConnectionStatus = 'changeSocketConnectionStatus';
export const getPartnerConfig = 'getPartnerConfig';
export const changeHelmeInfio = 'changeHelmeInfio';
export const setConfigs = 'setConfigs';
